import { EntityService } from './EntityService';

export class GlobalAlertService extends EntityService {
    constructor() {
        super("GlobalAlerts"); 
    }
}
